import React from "react";
import useProps from "./useProps";
import Layout from "./Layout";

export default () => <Layout {...useProps()} />;
